export default "__VITE_ASSET__MZTTO8GC__"